/* ================================================================
   authConfig.ts — shared constants for the home-page auth flow.
   ================================================================ */

import { REGION } from './region';

/**
 * Where an authenticated user is sent after login. The home page never holds a
 * session of its own — it logs in, then hands the JWT to the app via the URL
 * fragment (see AuthContext.redirectToApp). Defaults to the market's app
 * (region.json apps.juristab); override per-environment with REACT_APP_APP_URL
 * (e.g. http://localhost:3000 when running the app locally).
 */
export const APP_URL = process.env.REACT_APP_APP_URL || REGION.apps.juristab;

/** Path on the app to land on after login. The app shows Legal Research at `/`, so default to Case Management — the tab a signed-in user starts their day in. */
export const APP_LANDING_PATH = process.env.REACT_APP_APP_LANDING_PATH || '/casemanagement';

/**
 * The browser always talks to this same-origin path. nginx (prod) and
 * setupProxy.js (dev) forward it to the backend and inject the API Gateway
 * x-api-key server-side, so the key never reaches the browser bundle — exactly
 * like the app's Next.js /api/proxy route.
 */
export const API_PROXY_BASE = '/api/proxy';

/**
 * Fragment param names used to hand the JWT to app.juristab.com. These MUST stay
 * in sync with the capture logic in juristab-frontend-app AuthContext.jsx.
 */
export const HANDOFF_PARAMS = {
  accessToken: 'access_token',
  idToken: 'id_token',
  refreshToken: 'refresh_token',
  email: 'email',
} as const;

/** Auth endpoints (backend paths only; API_PROXY_BASE is prepended by the api layer). */
export const AUTH_ENDPOINTS = {
  login: 'integration-profile-auth/login/email',
  signup: 'integration-profile-auth/signup',
  verifyEmail: 'integration-profile-auth/verify-email',
  resendVerify: 'integration-profile-auth/resend-verification',
  forgotPassword: 'integration-profile-auth/forgot-password',
  confirmForgotPassword: 'integration-profile-auth/confirm-forgot-password',
} as const;
